module.exports = __webpack_public_path__ + "img/On-Occassion.f8db77e0.jpg";